module.exports = __webpack_public_path__ + "media/listening-start.wav";